import React, { useContext, useState } from "react";
import { useNavigation } from '@react-navigation/native'; // esto te sirve para navegar en el ambiente donde invocaste este componente
import { View, 
         Image, 
         StyleSheet,
         Platform,
         Dimensions,
         TouchableOpacity } from "react-native";
import { Image as ImageCache } from "react-native-expo-image-cache";
import { Video, Audio, AVPlaybackStatus } from 'expo-av';

//import useAuth from "../auth/useAuth";
import routes from "../navigation/routes";
import dateNow from "../utility/dateNow";
import configurationPost from "../config/configurationPost";
import connectionConfig from "../config/settings";      
import Text from "./Text";
import colors from "../config/colors";
import { AntDesign, MaterialCommunityIcons, Entypo, Fontisto, Foundation, Ionicons, FontAwesome5, Octicons } from "@expo/vector-icons";
import dateActions from "../utility/dateActions";
import AuthContext from "../auth/context";
import textStyles from "../config/textStyles";


var windowWidth = Dimensions.get('window').width;


const webUrl = connectionConfig.imageUrl + '/seedImages/'
var profileUri =  connectionConfig.imageUrl +'/PerfilDeUsuario/'
var infoDocumetUri =  connectionConfig.imageUrl +'/Documents/'  
var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
var date = dateNow()
var numLikes = 0

function CardSeed({ 
                title,
                seedDescription, 
                subTitle, 
                imageUrl, 
                onPress, 
                onPressComment, 
                onPressNumLikes,
                thumbnailUrl,
                commentsNum,
                totalActions,
                seedId,
                origin,
                type,
                userId,
                reRenderActionsForLike,
                getDataFromSeedActions,
                screen,
                seedDate,
                userIdOfAction,
                userName,
                userPhoto
                }) { 

const navigation = useNavigation(); // esto te sirve para navegar en el ambiente donde invocaste este componente
const video =React.useRef(null);
const [status, setStatus] = useState({});
const { user } = useContext(AuthContext)

var dateFormated = dateActions(seedDate)
var userIdAuth = JSON.parse(user).userId;


// ***************************************     Inicia block de los likes    ***************************************************
//---------------------------------------------------------------------------------------------------------------------------
//  1. Servicio que valida si ya existe el like del usuario en la publicación (función inicio del encadenamiento de servicios) 
//---------------------------------------------------------------------------------------------------------------------------
const onPressValidationLikeUser = async () => {
  try {
    const { sound } = await Audio.Sound.createAsync(
      require('../assets/sounds/ringtones-heart.mp3')   // Ejecuta un sonido al hacer like  
    )
    await sound.playAsync()
  } catch (err) {
    console.log(':(', err )
  }
  debugger
  var post_values = {
   seedId :  seedId, //filtroListing.seedId,
   userId :  userId  //JSON.parse(user).userId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/SelectValidateSeedsLikes/', configurationPost)
  .then(response => response.json())
  .then(response => {
    if (response.data.length != 0) {   
       deleteLikePublication()
    } else {
      insertLike()           
     }
  })
  .catch(err =>{
  console.log(':( review internet service', err )
  })
}

//--------------------------------------------------------
// 2. servicio que borra el like si ya existe en la publicación
//---------------------------------------------------------
const deleteLikePublication = async () => {
  var post_values = {
    seedId : seedId,
    userId : userId  //JSON.parse(user).userId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/deleteLikeSeeds/', configurationPost)
  .then(response => response.json())
  .then(response => {
    countOfLikes()
   })
   .catch(err =>{
   console.log(':( review internet service /deleteLikeSeeds/', err )
   })
}   

//-------------------------
// 2.1. Agrega un nuevo like 
//-------------------------
const insertLike = async  () => {
   // debugger
  var post_values = {
      seedId : seedId,    //filtroListing.seedId, 
      userId : userId,    //JSON.parse(user).userId,
      dateLikeSeed : date,
      likeType : 1
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/insertSeedLike/', configurationPost) 
  .then(response => response.json())
  .then(response => {
    countOfLikes()    
  })
  .catch(err =>{
  console.log('Insert fixo failed :( review internet service -> insertSeedLike', err )
  })
}

//------------------------------------------------------------------
// 3. Servicio que nos va a traer el count de likes por semilla.
//------------------------------------------------------------------
const countOfLikes = async () => {
   var post_values = {
      seedId : seedId    //filtroListing.seedId, 
    }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/SelectCountSeedLikes/', configurationPost)
   .then(response => response.json())
   .then(response => {
     numLikes = response.data[0].total_likes
     incrementLikes()
     
   })
   .catch(err =>{ 
   console.log(':( review internet service => /SelectCountSeedLikes/', err )
   })
}
//------------------------------------------------------------------------------
// 4. servicio que hace un incremeto al campo de número de likes de una semilla
//------------------------------------------------------------------------------
const incrementLikes = async () => {
        //debugger

        var post_values = {
          seedId : seedId, //filtroListing.seedId, 
          totalSeedLikes : numLikes
      }
      configurationPost.body = JSON.stringify(post_values)
      await fetch(connectionConfig.apiUrl+'/UpdateIncrementLikeSeeds/', configurationPost) 
      .then(response => response.json())
      .then(response => {
        //pageNumber = 0
        reRenderActionsForLike2()
      })
      .catch(err =>{
      console.log('Insert fixo failed :( review internet service /UpdateIncrementLikeSeeds/', err )
      })
}

//------------------------------------------------------------------------------------------
// Función que invoca la función getActionsList via props desde ListingDetailsSeedScreen 
//------------------------------------------------------------------------------------------
const reRenderActionsForLike2 = async () => {
  reRenderActionsForLike()
}

// ********************************************* Termina block de los likes  *********************************************//


//-----------------------------------------------------------------------------------------------
// Función que invoca la función getDataFromSeedActions via props desde ListingDetailsSeedScreen 
//-----------------------------------------------------------------------------------------------
const getDataFromSeedActions2 = async () => {
  //getDataFromSeedActions()
}

const selectOnPressBetween = async () => {
  { console.log({screen})
    if({screen} === "ListingsSeedsScreen"){
    {onPress}
  }else{getDataFromSeedActions}
 }
}
//alert( profileUri + userId + '_' + userPhoto)

  return (

      <View style={styles.card}>
        <View>
        {/* <View style={
                    type === 1 ? styles.fondo1 :
                      type === 2 ? styles.fondo2 :
                        type === 3 ? styles.fondo3 :
                          type === 4 ? styles.fondo4 :
                            type === 5 ? styles.fondo5 :
                              type === 6 ? styles.fondo6 :
                                type === 7 ? styles.fondo7 :
                                    styles.fondo9
                  }> */}
      <View style={styles.containerPhotoNameUser}> 
            <View style={styles.viewImageUser} > 
                        { 
                            (Platform.OS === 'ios') ?  
                                imageUrl === 'http://18.116.234.21:5001/imagenes/PerfilDeUsuario' ?
                                      <View style={styles.imageUser} >
                                                  <Foundation 
                                                    name="mountains" 
                                                    size={100}         //100
                                                    color={colors.medium} />
                                      </View>
                          :   
                            <TouchableOpacity
                                  onPress={() => {
                                      var item = {userId, userPhoto, userName}
                                      var foundUserChecker = "foundUserChecker"
                                      {if(userId === userIdAuth){
                                        navigation.navigate(routes.USER_FIXO)
                                      }else{
                                      navigation.navigate(routes.FOUND_USER, { item, foundUserChecker })
                                      }}
                                    }}
                                  >
                                  <ImageCache
                                    style={styles.imageUser}
                                    tint="light"
                                    preview={{ uri: thumbnailUrl }}
                                    uri={profileUri + userIdOfAction + '_' + userPhoto}
                                  />
                            </TouchableOpacity>  
                          :
                          null           
                        }
                        { 
                            (Platform.OS === 'web') ?  
                                imageUrl === 'http://18.116.234.21:5001/imagenes/PerfilDeUsuario' ?
                                      <View style={styles.imageUser} >
                                                  <Foundation 
                                                              name="mountains" 
                                                              size={100}   //100 
                                                              color={colors.medium} />
                                      </View>
                          :   
                            <TouchableOpacity
                                //style={styles.imageUser}
                                onPress={() => {
                                    var item = {userId, userPhoto, userName}
                                    var foundUserChecker = "foundUserChecker"
                                        {if(userId === userIdAuth){
                                          navigation.navigate(routes.USER_FIXO)
                                        }else{
                                        navigation.navigate(routes.FOUND_USER, { item, foundUserChecker })
                                        }}
                                      }}
                                    >
                                <Image
                                    style={styles.imageUser}
                                    tint="light"
                                    preview={{ uri: thumbnailUrl }}
                                    source={{uri: profileUri + userIdOfAction + '_' + userPhoto}}
                                  />
                            </TouchableOpacity>  
                          :
                            null           
                        }
                    </View>
                <Text style={styles.userName}> {userName}  </Text>
      <View style={styles.containerIcon}>
          {
            type === 1 ?
                 <View style={styles.viewIconAndNameAction}>
                     <Text style={{fontSize: textStyles.textSmall,
                                   color: colors.textGeneral,
                                  marginRight:2}}
                     > 
                        Información 
                     </Text>
                     <View style={styles.iconOfAction1}>                          
                              <AntDesign                         
                              name={"infocirlceo"} 
                              color={colors.chakra1nar} 
                              size={20} 
                              onPress={ onPress }
                              />                                 
                     </View>
                 </View>
         :
            type === 2 ?
                  <View style={styles.viewIconAndNameAction}>
                      <Text style={styles.actionName}> Idea </Text>
                      <View style={styles.iconOfAction2}>  
                          
                              <MaterialCommunityIcons                         
                                  name={"lightbulb-on-outline"} 
                                  color={colors.chakra2ama} 
                                  size={20}
                                  onPress={ onPress } 
                                />
                                 
                      </View>
                  </View>
          :
            type === 3 ?
                 <View style={styles.viewIconAndNameAction}>
                    <Text style={styles.actionName}> Plan </Text>
                    <View style={styles.iconOfAction3}>  
                         
                            <Fontisto                         
                                name={"map"} 
                                color={"green"} 
                                size={16} 
                                onPress={ onPress }
                              />
                               
                    </View>
                </View>
          :
            type === 4 ?
                 <View style={styles.viewIconAndNameAction}>
                    <Text style={styles.actionName}> Acción </Text>
                    <View style={styles.iconOfAction4}>  
                        
                            <FontAwesome5                         
                                name={"people-carry"}   //tractor people-carry
                                color={"blue"} 
                                size={15} 
                                onPress={ onPress }
                              />
                                
                    </View>
                 </View>
          :
            type === 5 ?
                 <View style={styles.viewIconAndNameAction}>
                    <Text style={styles.actionName}> Atraer personas </Text>
                    <View style={styles.iconOfAction5}>  
                        
                            <Octicons                         
                                name={"megaphone"} 
                                color={colors.chakra5vlt} 
                                size={20} 
                                onPress={ onPress }
                              />
                                
                    </View>
                 </View>
          :
          type === 6 ?
               <View style={styles.viewIconAndNameAction}>
                  <Text style={styles.actionName}> Hacer divertida la semilla </Text>
                  <View style={styles.iconOfAction6}>  
                      
                            <FontAwesome5                         
                                name={"hat-wizard"} 
                                color={colors.chakra6rsa} 
                                size={19} 
                                onPress={ onPress }
                            />
                             
                  </View>
               </View>
          :
          type === 7 ?
               <View style={styles.viewIconAndNameAction}>
                  <Text style={styles.actionName}> Ramifica esta semilla </Text>
                  <View style={styles.iconOfAction7}>  
                      
                            <Fontisto                         
                                name={"sourcetree"} 
                                color={colors.chakra7ryo} 
                                size={19} 
                                onPress={ onPress }
                            />
                             
                  </View>
               </View>
          :
          null
    }
    </View>
      </View>  



            {/* <TouchableOpacity onPress={onPress}> */}
              <View style={styles.primerRow}>

                   <View style={styles.titleDescription}>
                      <Text style={styles.title} >
                          {title}
                      </Text>
                      <Text style={styles.date} >
                          {dateFormated}
                      </Text>
                        <View style={styles.likeAndCommentContainer}> 
                                <Text style={styles.tree} numberOfLines={1} >
                                    <Entypo name={"tree"}
                                            color={colors.commentsIcon} 
                                            size={colors.miniSizeTree} 
                                            onPress={ onPress }
                                        />                
                                </Text>
                                <Text style={styles.totalActions} // Número de acciones(ramas)Tree
                                        numberOfLines={1} >
                                        {totalActions}
                                </Text>
                          <Text style={styles.comments} numberOfLines={1} >
                              <Ionicons name={"ios-people"} 
                                                      color={colors.commentsIcon} 
                                                      size={colors.sizeTree} 
                                                      onPress={onPressComment} 
                              /> 
                          </Text>
                          <Text style={styles.totalActions} // Número de acciones(ramas)Tree
                                        numberOfLines={1} >
                                        {totalActions}
                                </Text>
                      </View>


                  </View>

                  

          
                {  (Platform.OS === 'web') ?
                imageUrl.includes('.mp4') ?
                <Video 
                ref = {video}
                style={type === 0 ? styles.image :
                  type === 1 ? styles.image1 :
                    type === 2 ? styles.image2 :
                      type === 3 ? styles.image3 :
                        type === 4 ? styles.image4 :
                          type === 5 ? styles.image5 :
                            type === 6 ? styles.image6 :
                              type === 7 ? styles.image7 :
                                type === 8 ? styles.image8 :
                                  styles.image9
                }
                source = {{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode = "stretch"  // Con esto la imagen se adecuará a un view más pequeño!! 

                isLooping
                onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                :
                imageUrl.includes('.mov') ?
                <Video 
                ref = {video}
                style={type === 0 ? styles.image :
                  type === 1 ? styles.image1 :
                    type === 2 ? styles.image2 :
                      type === 3 ? styles.image3 :
                        type === 4 ? styles.image4 :
                          type === 5 ? styles.image5 :
                            type === 6 ? styles.image6 :
                              type === 7 ? styles.image7 :
                                type === 8 ? styles.image8 :
                                  styles.image9
                }
                source = {{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode = "stretch"
                isLooping
                onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                : 
                imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
                <View style={styles.imageMountain} >
                            <Foundation //style={styles.imageMountain}
                                        name="mountains" 
                                        size={100} 
                                        color={colors.medium} />
                </View>
                :               
                <Image
                  resizeMode = "stretch"
                  onPress={onPress}
                  style={type === 0 ? styles.image :
                    type === 1 ? styles.image1 :
                      type === 2 ? styles.image2 :
                        type === 3 ? styles.image3 :
                          type === 4 ? styles.image4 :
                            type === 5 ? styles.image5 :
                              type === 6 ? styles.image6 :
                                type === 7 ? styles.image7 :
                                  type === 8 ? styles.image8 :
                                    styles.image9
                  }
                  tint="light"
                  preview={{ uri: thumbnailUrl }}
                  //uri={imageUrl}
                  source={{ uri: imageUrl }}
                />
                :
                null
              }
                  
              </View>
        </View>  
      </View>

  );
}

const styles = StyleSheet.create({
  containerPhotoNameUser: {
    flexDirection: "row",
    width: '100%',//(windowWidth * .5),
    //backgroundColor: "white",
    marginBottom: 5//(windowWidth * -.085)
    },
  containerIcon: {
    alignSelf: "flex-end", 
    //marginRight: (windowWidth * .015),
    //marginTop: (windowWidth * .01),
    alignContent:'center',
    alignItems:'center',
    //backgroundColor: "red", 
    width: "50%"
    },
  viewIconAndNameAction: {
    flexDirection: "row",
    alignSelf: "flex-end", 
    //backgroundColor: "blue", 
    alignItems: "center",
  },
  iconOfAction1: { 
    flexDirection: "row",
    height:45, //(windowWidth * .08),   
    width: 45,//(windowWidth * .08),  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra1nar,    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginRight: 3,//"4%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
  iconOfAction2: { 
    flexDirection: "row",
    height:  45,//(windowWidth * .08),   
    width: 45, //(windowWidth * .08),  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra2ama,    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginRight:3,/// "2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction3: { 
    flexDirection: "row",
    height: 45,//(windowWidth * .08),   
    width: 45,// (windowWidth * .08),  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra3ver,    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginRight:3,// "2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction4: { 
    flexDirection: "row",
    height:45,   
    width: 45,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "blue",    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginRight: 3,//"2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction5: { 
    flexDirection: "row",
    height: 45,   
    width: 45,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra5vlt,    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginRight: 3,//"2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction6: { 
    flexDirection: "row",
    height: 45,   
    width: 45,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra6rsa,    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginRight: 3,//"2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
iconOfAction7: { 
    flexDirection: "row",
    height:45,   
    width: 45,  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra7ryo,    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 2,
    alignSelf: "flex-end", 
    marginRight: 3,//"2%", 
    marginTop: 3,
    backgroundColor: colors.fondoImagenes  
    },
  actionName: {
    fontSize: textStyles.textSmall,
    color: colors.textGeneral,
    //marginTop: "4%",
    //textAlignVertical: "bottom",
    marginRight: "1.5%",
  },
  userName: {
    fontSize: textStyles.textSmall,
    color: colors.textGeneral,
    width: '100%',
    //height: '100%',
    marginTop: "3%",
    marginLeft: "4%"
  },
  imageUser: {
    width: 34,
    height: 34,
    borderRadius: 36,
//borderColor:'red',
//borderWidth: 4,
    marginTop: "9%",
    marginLeft: "12%",
  },
  card: {
    width:'100%',
    //borderRadius: 15,
   // marginTop: 1,
    backgroundColor: colors.fondoImagenes,        //colors.verdeCaribe,
   // overflow: "hidden",
  },
  fondo1: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra1nar
  },
  fondo2: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra2ama
  },
  fondo3: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra3ver
  },
  fondo4: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra4azu
  },
  fondo5: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra5vlt
  },
  fondo6: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra6rsa
  },
  fondo7: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra7ryo
  },
  fondo9: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra9aur
  },
  primerRow: {
    flexDirection: "row", 
    width: "100%",

  },
  titleDescription: {
    width: "70%",
  },
  detailsContainer: {
    padding: 20,
  },
  imageMountain: {
    width: "100%",
    height: 100,
    alignItems: "center"
  },
  likeAndCommentContainer: {
     flexDirection: "row",
     width: "100%",
     height: (windowWidth * .07),  //35,
     alignItems: "baseline",
  },
  likeAndCommentNumbersContainer: {
    flexDirection: "row",
    width: "100%",
    height: 40,
    marginTop: "-1%",
 },
  likes: {
    marginLeft: "20%",
 },
  totalActions:{
  marginLeft: "3%",
  marginTop: "0.7%",
  color: colors.commentsIcon,
  fontSize: colors.textMedium,
  fontWeight: colors.fontWeightMedium
 },
 commentsNum:{
  marginLeft: "40%",
  color: colors.textGeneral,
  fontSize: colors.textSmall,
 },
 comments:{
  marginLeft: "20%",
  color: colors.medium,

 },
 tree:{
  marginLeft: "10%",
  color: colors.medium,
 },
  subTitle: {
    color: colors.textGeneral,
    fontSize: colors.textSmall,
    marginLeft: "4%"
  },
  title: {
    marginTop: "1%",
    width: "98%",
    marginLeft: "2%",
   // marginRight: "3%",
    marginBottom: 3,
    //fontSize: textStyles.textMedium,   //18,
    //fontWeight: textStyles.fontWeightLarge,  //"600",
    textAlign: "justify",
    color: colors.textGeneral
  },
  date: {
    marginTop: "1%",
    width:"59%",
    marginLeft: "2%",
    marginRight: "3%",
    marginBottom: 3,
    fontSize: textStyles.textSmall,   //18,
    color: colors.textGeneral
  },
  description: {
    width: "59%",
    marginLeft: "2%",
    marginRight: "3%",
    marginBottom: 7,
    fontSize: 18,
    textAlign: "justify"
  },
  image: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: 100,
    height: 100,
  },
  image1: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: 100,
    height: 100,
    borderWidth: 4,
    borderColor: colors.chakra1nar,
    backgroundColor:'red'
  },
  image2: {
    marginTop: "1.5%",
    marginLeft: "1%",
    marginBottom: "1%",
    borderRadius: 15,
    width: 100,
    height: 100,
    borderWidth: 4,
    borderColor: colors.chakra2ama
  },
  image3: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: 100,
    height: 100,
    borderWidth: 4,
    borderColor: colors.chakra3ver
  },
  image4: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width:  100,
    height: 100,
    borderWidth: 4,
    borderColor: colors.chakra4azu
  },
  image5: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: 100,
    height: 100,
    borderWidth: 4,
    borderColor: colors.chakra5vlt  //colors.chakra5vlt
  },
  image6: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: 100,
    height: 100,
    borderWidth: 4,
    borderColor: colors.chakra6rsa
  },
  image7: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: 100,
    height: 100,
    borderWidth: 4,
    borderColor: colors.chakra7ryo
  },
  image9: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //100,
    height: (windowWidth * 0.18),   //100,
    borderWidth: 4,
    borderColor: colors.chakra9aur
  },
});

export default CardSeed;
